const state = {
    agent_id: null,
}

const actions = {
    setAgentId({commit}, payload) {
        commit('SET_AGENT_ID', payload)
    }
}

const mutations = {
    'SET_AGENT_ID'(state, payload) {
        state.agent_id = payload
    },
}

const getters = {
    AGENT_ID: state => {
        return state.agent_id
    },
}

export default {
    state,
    actions,
    mutations,
    getters
}